import {
  Sun, LayoutDashboard, UserPlus, Flame, Users, Contact, Target, KanbanSquare, FileText,
  CheckSquare, Bell, Calendar, MessageSquare, FolderOpen, BarChart3, Settings, HeartPulse,
  UsersRound, CreditCard, Plug, Sparkles, Goal, LayoutTemplate, LifeBuoy, HardHat, ScrollText,
  FileSignature, PiggyBank, ShieldCheck, Scale, Zap, DatabaseBackup,
} from "lucide-react";

export const NAV = [
  { section: "Pilotage", items: [
    { to: "/aujourdhui", label: "Aujourd'hui", icon: Sun, testid: "nav-aujourdhui" },
    { to: "/", label: "Tableau de bord", icon: LayoutDashboard, testid: "nav-dashboard", end: true },
    { to: "/sante", label: "Santé & Analyses", icon: HeartPulse, testid: "nav-sante" },
    { to: "/rentabilite", label: "Rentabilité", icon: PiggyBank, testid: "nav-rentabilite" },
    { to: "/objectifs", label: "Objectifs de vente", icon: Goal, testid: "nav-objectifs" },
  ]},
  { section: "CRM", items: [
    { to: "/prospects", label: "Prospects", icon: UserPlus, testid: "nav-prospects" },
    { to: "/priorites", label: "Priorités IA", icon: Flame, testid: "nav-priorites" },
    { to: "/clients", label: "Clients", icon: Users, testid: "nav-clients" },
    { to: "/contacts", label: "Contacts", icon: Contact, testid: "nav-contacts" },
    { to: "/opportunites", label: "Opportunités", icon: Target, testid: "nav-opportunites" },
    { to: "/pipeline", label: "Pipeline de ventes", icon: KanbanSquare, testid: "nav-pipeline" },
    { to: "/soumissions", label: "Soumissions", icon: FileText, testid: "nav-soumissions" },
    { to: "/signatures", label: "Signature électronique", icon: FileSignature, testid: "nav-signatures" },
  ]},
  { section: "Productivité", items: [
    { to: "/taches", label: "Tâches", icon: CheckSquare, testid: "nav-taches" },
    { to: "/relances", label: "Relances auto", icon: Bell, testid: "nav-relances" },
    { to: "/automatisations", label: "Automatisations", icon: Zap, testid: "nav-automatisations" },
    { to: "/calendrier", label: "Calendrier", icon: Calendar, testid: "nav-calendrier" },
    { to: "/communications", label: "Communications", icon: MessageSquare, testid: "nav-communications" },
    { to: "/modeles", label: "Modèles", icon: LayoutTemplate, testid: "nav-modeles" },
    { to: "/documents", label: "Documents", icon: FolderOpen, testid: "nav-documents" },
    { to: "/rapports", label: "Rapports", icon: BarChart3, testid: "nav-rapports" },
  ]},
  { section: "Assistance", items: [
    { to: "/assistant-ia", label: "Assistant IA", icon: Sparkles, testid: "nav-assistant-ia" },
    { to: "/mode-chantier", label: "Mode chantier", icon: HardHat, testid: "nav-mode-chantier" },
    { to: "/support", label: "Support technicien", icon: LifeBuoy, testid: "nav-support" },
  ]},
  { section: "Système", items: [
    { to: "/utilisateurs", label: "Utilisateurs", icon: UsersRound, testid: "nav-utilisateurs" },
    { to: "/audit", label: "Journal d'audit", icon: ScrollText, testid: "nav-audit" },
    { to: "/sauvegardes", label: "Sauvegardes & corbeille", icon: DatabaseBackup, testid: "nav-sauvegardes" },
    { to: "/securite", label: "Sécurité", icon: ShieldCheck, testid: "nav-securite" },
    { to: "/conformite", label: "Conformité & confidentialité", icon: Scale, testid: "nav-conformite" },
    { to: "/abonnements", label: "Abonnements", icon: CreditCard, testid: "nav-abonnements" },
    { to: "/integrations", label: "Intégrations", icon: Plug, testid: "nav-integrations" },
    { to: "/parametres", label: "Paramètres", icon: Settings, testid: "nav-parametres" },
  ]},
];
